import { useFormContext } from 'react-hook-form'

import { Log } from '@/types/logs'
import { useGetEmployees } from '@/modules/Auth/api/useGetEmployees'
import { Input } from '@/components/Forms'
import { getLogCommonInformation } from '@/helpers/logInformation'
import { OFFICIAL_REPORT_FORM_FIELDS } from '../../constant'

import styles from '../OfficialReportModal.module.scss'

interface Props {
    log: Log
    warningText?: string
}

const DRIVER_EMPLOYEE_NUMBER_MAX_LENGTH = 7

interface DriverEmployeeNumberInputProps {
    warningText?: string
}

const DriverEmployeeNumberInput = ({ warningText }: DriverEmployeeNumberInputProps) => {
    const { register, watch } = useFormContext()
    const employeeNumber = watch(OFFICIAL_REPORT_FORM_FIELDS.driverEmployeeNumber)

    const { data: employees = [] } = useGetEmployees()
    const selectedDriver = employees.find((employee) => employee.badgeNumber === employeeNumber)

    return (
        <div className={styles.inputWithDescription}>
            <Input
                className={styles.inputField}
                fullWidth
                label="Driver employee number"
                placeholder="Employee number"
                maxLength={DRIVER_EMPLOYEE_NUMBER_MAX_LENGTH}
                warningText={warningText}
                {...register(OFFICIAL_REPORT_FORM_FIELDS.driverEmployeeNumber)}
            />
            {selectedDriver && (
                <div className={styles.informationWrapper}>
                    <span className={styles.label}>Driver</span>
                    <span className={styles.text}>
                        {selectedDriver.firstName} {selectedDriver.lastName}
                    </span>
                </div>
            )}
        </div>
    )
}

export const DriverAndVehicle = ({ log, warningText }: Props) => {
    const { baseDepot, duty, routes, run, fleet, trip } = getLogCommonInformation(log)

    return (
        <div className={styles.wrapper}>
            <p className={styles.subtitle}>Driver & vehicle</p>
            <div className={styles.contentWrapper}>
                <div className={styles.informationWrapper}>
                    <span className={styles.label}>Base depot</span>
                    <span className={styles.text}>{baseDepot || '-'}</span>
                </div>
                <div className={styles.informationContainer}>
                    <div className={styles.informationWrapper}>
                        <span className={styles.label}>Duty</span>
                        <span className={styles.text}>{duty || '-'}</span>
                    </div>
                    <div className={styles.informationWrapper}>
                        <span className={styles.label}>Route</span>
                        <span className={styles.text}>{routes || '-'}</span>
                    </div>
                    <div className={styles.informationWrapper}>
                        <span className={styles.label}>Running number</span>
                        <span className={styles.text}>{run || '-'}</span>
                    </div>
                    <div className={styles.informationWrapper}>
                        <span className={styles.label}>Fleet</span>
                        <span className={styles.text}>{fleet || '-'}</span>
                    </div>
                    <div className={styles.informationWrapper}>
                        <span className={styles.label}>Trip</span>
                        <span className={styles.text}>{trip || '-'}</span>
                    </div>
                </div>
            </div>
            <DriverEmployeeNumberInput warningText={warningText} />
        </div>
    )
}
